import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Menu, Icon } from 'antd';
import HeaderComponent from '../../components/HeaderComponent';
import DoctorBasicProfileScreen from './DoctorBasicProfileScreen';
import DoctorEducationScreen from './DoctorEducationScreen';
import DoctorExperienceScreen from './DoctorExperienceScreen';
import DoctorAwardsScreen from './DoctorAwardsScreen';
import DoctorMembershipScreen from './DoctorMembershipScreen';
import DoctorRegistrationsScreen from './DoctorRegistrationsScreen';
import DoctorServicesScreen from './DoctorServicesScreen';
import DoctorSpecializationsScreen from './DoctorSpecializationsScreen';
import DoctorPracticeCenterScreen from './DoctorPracticeCenterScreen';
import DoctorSlots from './DoctorSlots';
import DoctorFulfilmentScreen from './DoctorFulfilmentScreen';
import DocumentsScreen from '../DocumentsScreen';
import SidebarComponent from '../../components/sidebarComponent';

const { Content, Sider } = Layout;

class ProfileScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedMenu: 'basicProfile',
      isSidebarOpen: false,
    };
    if (!props.authToken) {
      props.history.push('/');
    }

    console.log(props.match);
    if (props.match.params.doctorId === 'new') {
      // New Doctor being created
      this.state.doctorId = -1;
    } else {
      this.state.doctorId = props.match.params.doctorId;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.doctorId !== this.props.match.params.doctorId) {
      this.setState({ doctorId: this.props.match.params.doctorId });
      window.location.reload();
    }
    
  }

  // onCollapse = collapsed => {
  //   console.log(collapsed);
  //   this.setState({ collapsed });
  // };

  toggleSidebar = () => {
    this.setState((prevState) => ({
      isSidebarOpen: !prevState.isSidebarOpen,
    }));
  };

  selectMenu = options => {
    console.log({ options }, 'select menu');
    this.setState({
      selectedMenu: options.key,
    });
  };

  getContent = () => {
    const { doctorId, selectedMenu, lastSelectedMenu } = this.state;
    const currentMenu = selectedMenu === 'backToMenu' ? lastSelectedMenu : selectedMenu;

    switch (currentMenu) {
      case 'basicProfile':
        return <DoctorBasicProfileScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'education':
        return <DoctorEducationScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'experience':
        return <DoctorExperienceScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'awards':
        return <DoctorAwardsScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'membership':
        return <DoctorMembershipScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'registrations':
        return <DoctorRegistrationsScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'services':
        return <DoctorServicesScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'specializations':
        return <DoctorSpecializationsScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'practiceCenter':
        return <DoctorPracticeCenterScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'slots':
        return <DoctorSlots doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
      case 'fulfilment':
        return <DoctorFulfilmentScreen doctorId={doctorId} />;
      case 'documents':
        return <DocumentsScreen doctorId={doctorId} />;
      default:
        return <DoctorBasicProfileScreen doctorId={doctorId} setDoctorId={(id) => this.setState({ doctorId: id })} />;
    }
  };

  render() {
    const { doctorId, isSidebarOpen } = this.state;
    return (
      <div>
        <HeaderComponent />
        <div style={{
          display: 'flex',
        }}>
          <div style={{ zIndex: 1 }}>

            {isSidebarOpen ? (
              <SidebarComponent isSidebarOpen={isSidebarOpen} toggleSidebar={this.toggleSidebar} />
            ) : (
          <Sider
            width={230}
            breakpoint="lg"
            collapsedWidth="0"
            collapsible
            style={{ height: '100%' }}
            // collapsed={this.state.collapsed}
            // onCollapse={this.onCollapse}
          >
            <div className="logo" />
            <Menu
              theme="dark"
              defaultSelectedKeys={['basicProfile']}
              mode="inline"
              onSelect={this.selectMenu}
            >
              <Menu.Item key="backToMenu" onClick={this.toggleSidebar}>
                <Icon type="arrow-left" />
                <span>Back to Menu</span>
              </Menu.Item>
              <Menu.Item key="basicProfile">
                <Icon type="pie-chart" />
                <span>Basic Profile</span>
              </Menu.Item>
              <Menu.Item
                key="practiceCenter"
                disabled={doctorId !== -1 ? false : true}
              >
                <Icon type="desktop" />
                <span>Practice Center</span>
              </Menu.Item>
              <Menu.Item key="slots" disabled={doctorId !== -1 ? false : true}>
                <Icon type="pie-chart" />
                <span>Slots</span>
              </Menu.Item>
              <Menu.Item
                key="education"
                disabled={doctorId !== -1 ? false : true}
              >
                <Icon type="desktop" />
                <span>Education</span>
              </Menu.Item>
              <Menu.Item
                key="experience"
                disabled={doctorId !== -1 ? false : true}
              >
                <Icon type="pie-chart" />
                <span>Experience</span>
              </Menu.Item>
              <Menu.Item key="awards" disabled={doctorId !== -1 ? false : true}>
                <Icon type="desktop" />
                <span>Awards</span>
              </Menu.Item>
              <Menu.Item
                key="fulfilment"
                disabled={doctorId !== -1 ? false : true}
              >
                <Icon type="pie-chart" />
                <span>Fulfilment</span>
              </Menu.Item>
              <Menu.Item
                key="membership"
                disabled={doctorId !== -1 ? false : true}
              >
                <Icon type="desktop" />
                <span>Membership</span>
              </Menu.Item>
              <Menu.Item
                key="registrations"
                disabled={doctorId !== -1 ? false : true}
              >
                <Icon type="pie-chart" />
                <span>Registrations</span>
              </Menu.Item>
              <Menu.Item
                key="services"
                disabled={doctorId !== -1 ? false : true}
              >
                <Icon type="desktop" />
                <span>Services</span>
              </Menu.Item>
              <Menu.Item
                key="specializations"
                disabled={doctorId !== -1 ? false : true}
              >
                <Icon type="pie-chart" />
                <span>Specializations</span>
              </Menu.Item>
              <Menu.Item
                key="documents"
                disabled={doctorId !== -1 ? false : true}
              >
                <Icon type="file-word" />
                <span>Doctor Documents</span>
              </Menu.Item>
            </Menu>
          </Sider>
            )}
            </div>
          <Layout
            style={{ overflow: 'scroll' }}>
            <Layout style={{ padding: '0 24px 24px' }}>
            <Content
              style={{
                background: '#fff',
                padding: 24,
                margin: 0,
                minHeight: 280,
                overflow: 'scroll',
              }}
            >
              {this.getContent()}
            </Content>
          </Layout>
          </Layout>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(ProfileScreen);
